import * as v from 'valibot';

export const lookupCodeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.string(),
  creationTime: v.string(), // UTC 2026-03-24T15:28:35.162Z
  creatorUserId: v.number(),
  id: v.number(),
  lastModificationTime: v.nullable(v.string()), // UTC 2026-03-24T15:28:35.162Z
  lastModifierUserId: v.nullable(v.number()),
  locked: v.nullable(v.string()),
  lookupCodeType: v.string(),
  standardCode: v.nullable(v.string()),
  status: v.nullable(v.string()),
  string1: v.nullable(v.string()),
  string2: v.nullable(v.string()),
  string3: v.nullable(v.string()),
  value1: v.nullable(v.number()),
  value2: v.nullable(v.number()),
  value3: v.nullable(v.number()),
});

export const lookupCodeListApiSchema = v.object({
  items: v.array(lookupCodeApiSchema),
  totalCount: v.number(),
});

export type LookupCodeApi = v.InferOutput<typeof lookupCodeApiSchema>;
export type LookupCodeListApi = v.InferOutput<typeof lookupCodeListApiSchema>;
